module.exports = __webpack_public_path__ + "static/media/nydi-product-image.919b022e.jpg";